module.exports = __webpack_public_path__ + "img/rocket_small.93a6702f.png";